export const state = () => ({
  loginDialog: false,
  loginDialogOptions: {},
  rootMessageDialog: false,
  rootMessageOptions: {},
  guideDownloadAppDialog: false,
  guideDownloadDialogOptions: {},
})

export const getters = {
  loginDialog: state => state.loginDialog,
  loginDialogOptions: state => state.loginDialogOptions,
  rootMessageDialog: state => state.rootMessageDialog,
  rootMessageOptions: state => state.rootMessageOptions,
  guideDownloadAppDialog: state => state.guideDownloadAppDialog,
  guideDownloadDialogOptions: state => state.guideDownloadDialogOptions,
}

export const actions = {
  setLoginDialog({ commit }, { state, options }) {
    commit('SET_LOGIN_DIALOG', !!state)
    commit('SET_LOGIN_DIALOG_OPTIONS', options || {})
  },
  setRootMessageOption({ commit }, { status, options }) {
    commit('SET_ROOT_MESSAGE_DIALOG', status)
    commit('SET_ROOT_MESSAGE_OPTIONS', options)
  },
  setGuideDownloadAppDialog({ commit }, { state = false, options = {} }) {
    commit('SET_GUIDE_DOWNLOAD_APP_DIALOG', state)
    commit('SET_GUIDE_DOWNLOAD_DIALOG_OPTIONS', options || {})
  },
}

export const mutations = {
  SET_LOGIN_DIALOG(state, dialogState) {
    state.loginDialog = dialogState
  },
  SET_LOGIN_DIALOG_OPTIONS(state, options) {
    state.loginDialogOptions = options
  },
  SET_ROOT_MESSAGE_DIALOG(state, dialogState) {
    state.rootMessageDialog = dialogState
  },
  SET_ROOT_MESSAGE_OPTIONS(state, options = {}) {
    state.rootMessageOptions = Object.assign({}, options)
  },
  SET_GUIDE_DOWNLOAD_APP_DIALOG(state, dialogState) {
    state.guideDownloadAppDialog = dialogState
  },
  SET_GUIDE_DOWNLOAD_DIALOG_OPTIONS(state, dialogOptions) {
    state.guideDownloadDialogOptions = dialogOptions
  },
}
